<template>
  <div id="map" :style="`height: ${config.height}`">
    <template v-if="!!this.google && !!this.map">
      <slot />
    </template>
  </div>
</template>
<script>
import GoogleMapsApiLoader from 'google-maps-api-loader'

export default {
  name: 'GoogleMap',
  props: {
    config: Object,
    apikey: String
  },
  data () {
    return {
      google: null,
      map: null
    }
  },
  mounted () {
    GoogleMapsApiLoader({
      apiKey: this.apikey
    }).then((google) => {
      this.google = google
      this.initMap()
    })
  },
  methods: {
    initMap () {
      const mapContainer = this.$el
      const { Map } = this.google.maps
      this.map = new Map(mapContainer, this.config)
    },
    processMarkerClick (marker) {
      this.$parent.processMarkerClick(marker)
    }
  }
}
</script>

<style>
#map {
  width: 100%;
  border-radius: 10px;
}
</style>
